var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1403.3 1514.7",
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 1403.3 1514.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1295.6,466.2c-85-65.8-175.7-67.5-290.6-45.2L852,450.9c0,0,28.1-45.8,38.5-108.1 c20.5-123.2-48-227-122.4-284.5C635.5-44.3,465.1-5.2,381.7,126.4L40.9,663.9c-79.2,125-35.9,289.6,66.5,368.8 c79.3,61.3,176.1,58.4,243.7,27.5c74.7-33.9,100.1-108.7,100.1-108.7c15.2,40.7,35,64.5,66.4,88.8c30.7,23.7,58.4,38.2,97.6,39.6 c0,0-38.1,41.7-56.6,104.7c-27,101.7,18.4,211.3,102.4,276.3c113.1,87.5,262.5,67.5,339.9-54.5l353-556.8 C1442.4,709.9,1405.4,551.2,1295.6,466.2",
    fill: "#currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLogo);
export default __webpack_public_path__ + "static/media/background_logo.49a55c95.svg";
export { ForwardRef as ReactComponent };